// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-windows"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 11V6.15152L10 5V11H3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M13 11V4.14286L21 3V11H13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M13 19.8333V14H21V21L13 19.8333Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M3 19.3333V14H10V20L3 19.3333Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M3 11V6.15152L10 5V11H3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M13 11V4.14286L21 3V11H13Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M13 19.8333V14H21V21L13 19.8333Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M3 19.3333V14H10V20L3 19.3333Z","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-logo-windows')
export default class LogoWindowsIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-windows',
    }
  }
}
